import { createContext as t, useContext as o } from "react";
const e = t({}), r = () => o(e);
export {
  e as ButtonsGroupContext,
  r as useButtonsGroupContext
};
